<div>
    <mat-form-field appearance="outline">
    <mat-select (selectionChange)="Selected()" [(ngModel)]="colonia">
        <mat-option default value="Selecciona una colonia">Selecciona una colonia</mat-option>
        <mat-option *ngFor="let colonia of colonias" [value]="colonia">{{colonia}}</mat-option>
        <mat-option value="Otra colonia">Otra colonia</mat-option>
    </mat-select>
</mat-form-field>
</div>